<script>
  export let data;
  export let remove;
  export let select;
  export let unselect;
  export let save;

import { init } from "svelte/internal";
  import {
    Button,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Col,
    Table,
    Label,  
    Collapse,
    CardHeader,
    CardTitle,
    CardBody,
    CardText,
CardColumns,
  } from "sveltestrap";

  import DataSetAddCol from "./DataSetAddCol.svelte";

  import DataSetFileUpload from './DataSetFileUpload.svelte'
  import DataSetGoogleSheet from './DataSetGoogleSheet.svelte';
  import { hashState, hashPut, hash } from './hash.js'
  import uuid from 'uuid-browser';

  import { from } from "./from";
  import { global} from './state';

  const sources = [
    { value: "file",       label: "Upload file",     readonly: false},
    { value: "sheet",      label: "Google Sheet",    readonly: false},
    { value: "text",       label: "Clipboard",       readonly: false},
    { value: "sql",        label: "SQL",             readonly: true},
    { value: "sharepoint", label: "Sharepoint",      readonly: true},
    { value: "dropbox",    label: "Dropbox",         readonly: true},
    { value: "s3",         label: "AWS S3",          readonly: true},
    { value: "azure",      label: "Azure Storage",   readonly: true},
    { value: "derived",    label: "Derived",         readonly: true},
    // { value: "saved", label: "Pre-saved"},
  ];

  const hashExpandedKey = data.id+"/expanded";
  const hashColsKey = data.id+"/columns";

  let addToggleOpen=false;
  let addColOpen=false;
  let editName="";

  let newInstanceKey = '';

  let minimal;
  let colToggleOpen;

  function syncFromHash(map) {
    minimal = map[hashExpandedKey] != "true";
    colToggleOpen=map[hashColsKey] == "true";
  }

  syncFromHash(hash());
  hashState.subscribe(syncFromHash);

  $: {
    hashPut(hashExpandedKey, !minimal);
    hashPut(hashColsKey, colToggleOpen);
  }

  function colToggle(ev) {
    console.log('cto', colToggleOpen);
    colToggleOpen!=colToggleOpen;    
  }

  if (!data.instances) {
    // use this to detect a new source
    data.instances = []
    minimal = false;
  } else {
    data.instances = data.instances.map(i => ({...i, selected:false}))
  }

  // use the object here? is this selected? what's the state model XXX
  let dsType = sources[0].value;

  // console.log({data})

  function onUpload(datasetInfo) {
    console.log("SimpleDataSetWidget.onupload")
    dsType = datasetInfo.dsType;
    dsName = datasetInfo.dsName;
    dsId   = datasetInfo.dsId;
  }

  function uploaded(resp) {
    let info = resp.uploaded[0]
    console.log("uploaded - info", info);
    if (!info) { return }

    if (!data.name) { 
      data.name = info.name;
    }
    data.loc = info.loc;
    data.instances = [{
      stamp: info.uploadTimestamp, 
      // stage: info.stage, 
      selected: false,
      uri: info.uri,
      name: data.name +" - copy",

      // colcount: info.colcount,
      // rowcount: info.rowcount,
      // errcount: info.errcount,
      ...info
      },
      ...data.instances];

    save();
  }

  function editNewInstance() {
    const newInstance = {...data.instances[0]};
    newInstance.tablename = undefined; // unless reified? upload/transform/diff merge :( 
    newInstance.id = uuid.v4();
    newInstance.stamp = new Date().toISOString();
    data.instances = [ newInstance, ...data.instances]
  }

  function toggle(instance) {
    console.log("toggle", instance.uri, instance.selected, instance)
    instance.selected = !instance.selected;
    if (instance.selected) {
      select(instance);
    } else {
      unselect(instance);
    }
    data.instances = data.instances;
  } 

  let name="ds";

  let result;

  function exportData (e) {
    if (e) e.preventDefault();

    const body = {
      config: { columns: data.instances[0].columns },
      uriA: data.instances[0].uri,
      action: "transform-only"
    };

    const opts = {
      method: "POST",
      body: JSON.stringify(body),
    };

    from(`/diff${global.noauth?"-noauth":""}?noauth=`+global.noauth, opts)
      .then((resp) => resp.json())
      .then((json) => {
        result = json;
        window.result = json;

        doDownload(json.rows)
      });

    return false;
  };

  function renderExport(rows) {
    return [
      data.instances[0].columns.filter(col => !col.hide).map(col=>col.name).reduce((s,v)=>s+v+",",""),
      ...(rows ? rows
        .map(row => data.instances[0].columns
                      .filter(col => !col.hide)
                      .map(col => row.hasOwnProperty(col.name) ? (typeof row[col.name]) === "number" ? row[col.name] : '"'+row[col.name]+'"': "")
                      .reduce((s,v)=>s+v+",","")
                      .slice(0,-1)) : []),
    ].reduce((s,v)=>s+v+"\n","")
  }

  function doDownload(rows) {
    // if (e) e.preventDefault();

    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(renderExport(rows))
    );
    element.setAttribute("download", "export.csv");
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  function doHideAll(e) {
    console.log('doHideAll',e.srcElement.checked);
    data.instances[0].columns.forEach(col => { col.hide = e.srcElement.checked });
    data = data;
  }

</script>
<style>
  textarea.form-control {
    height: 10rem;
  }

  .offset {
    position: relative;
    left: 1.4rem;
    top: 1rem;
    margin: -0.444rem;
  }

  .form-check-input.cbinput {
    position: relative;
    margin: 0.75rem;
  }

  .inputPrefix {
    width: 5rem;
  }
</style>

{#if (minimal)} 
  <!-- 
  <tr>
    <th>Name</th>
    <th>Date/time</th>
    <th>Type</th>
    <th>Rows</th>
    <th>Action</th>
  </tr> -->

  {#if data.instances.length == 0} 
  <tr>
    <!-- <td>{data.name || ""}</td> -->
    <td colspan=6></td>
    <td>
<!-- svelte-ignore a11y-missing-attribute -->
      <a on:click={()=>{minimal=false}}>Detail</a>&nbsp;&nbsp;&nbsp;
      
    </td>
  </tr>
  {:else}
    {#each data.instances as instance,i}
      <tr>
        <td style={ i>0 ? "border-top: 0" : ""}>{i == 0 ? data.name : ""}</td>
        <td style={ i>0 ? "border-top: 0" : ""}>{instance.stamp}</td>
        <td style={ i>0 ? "border-top: 0" : ""}>{instance.stage}</td>
        <td style={ i>0 ? "border-top: 0" : ""}>{instance.colcount}</td>
        <td style={ i>0 ? "border-top: 0" : ""}>{instance.rowcount}</td>
        <td style={ i>0 ? "border-top: 0" : ""}>{instance.errcount}</td>
        <td style={ i>0 ? "border-top: 0" : ""}>
          <!-- svelte-ignore a11y-missing-attribute -->
          <a on:click={()=>{minimal=false}}>Detail</a>&nbsp;&nbsp;&nbsp;
          <!-- svelte-ignore a11y-missing-attribute -->
          <a on:click={()=>toggle(instance)}>{
            instance.selected ? "Unselect" : "Select"
          }</a>
        </td>
      </tr>
    {/each}
  {/if}
{:else}
<tr>
  <!-- <td>{data.name || ""}</td> -->
  <td colspan=6>
  <div class="form-group col-sm col-lg">
    <Card body width="100%">
      <!-- <InputGroup>
        <InputGroupAddon addonType="prepend">
          <InputGroupText class='inputPrefix'>Id</InputGroupText>
        </InputGroupAddon>
        <Input value={data.id} readonly /> 
        <InputGroupAddon addonType="append">
          <InputGroupText><span on:click={remove}><i class="fa fa-trash"></i></span></InputGroupText>
        </InputGroupAddon>  
      </InputGroup> -->

      <InputGroup>
        <InputGroupAddon addonType="prepend">
          <InputGroupText class='inputPrefix'><span title="{data.id}">Name</span></InputGroupText>
        </InputGroupAddon>
        <Input bind:value={data.name} placeholder="New source name here" />
        <InputGroupAddon addonType="append">
          <InputGroupText><span on:click={remove}><i class="fa fa-trash"></i></span></InputGroupText>
        </InputGroupAddon>  
      </InputGroup>

      <InputGroup>
        <InputGroupAddon addonType="prepend">
          <InputGroupText class='inputPrefix'>Flags</InputGroupText>
        </InputGroupAddon>
        <Label check >
          <input type="checkbox" class="cbinput form-check-input" bind:checked={data.perInstanceKey} style="position: relative" />Use per-upload-instance key
        </Label>
        <Label check >
          <input type="checkbox" class="cbinput form-check-input" bind:checked={data.replacePrevious} style="position: relative" />Replace previous (vs append)
        </Label>
        <Label check >
          <input type="checkbox" class="cbinput form-check-input" bind:checked={data.failExact} />Fail on same data
        </Label>
      </InputGroup>

      {#if data.instances.length > 0}
      <div>
        Available versions: 
      </div>
      <Card body class="col-12">
        <div class=row>
          <div class=col>
            <Table>
              <tr>
                <td>Date/time</td>
                <td title='Imported data is "raw", when filtered or processed, new labels are added'>Stage (*)</td>
                <td>Columns</td>
                <td>Rows</td>
                <td>Errors</td>
              </tr>
              {#each data.instances as instance}
                <tr>
                  <td>{instance.stamp}</td>
                  <td>{instance.stage}</td>
                  <td>{instance.colcount}</td>
                  <td>{instance.rowcount}</td>
                  <td>{instance.errcount}</td>
                </tr>
              {/each}
            </Table>  
          </div>
        </div>
      </Card>
      {/if}  

        <!-- svelte-ignore a11y-missing-attribute -->
      <div><a href="javascript:void(0)" on:click={()=>{colToggleOpen=!colToggleOpen}}>{!colToggleOpen ? "Hide" : "Show"} columns</a></div>
      {#if !colToggleOpen }
        <div class="row">
          <div class="col-12">
            {#if data.instances.length == 0 || !data.instances[0].columns} 
            <!-- No data yet. {JSON.stringify(data.instances[0])} -->
            {:else}
              
              <Card body>
                <div class=mb-1>
                  <Button on:click={editNewInstance} class='btn-sm'>Edit new version</Button>
                  <Button on:click={()=>{addColOpen=true}} class='btn-sm'>Add column</Button>
                  <Button on:click={exportData} class='btn-sm'>Export</Button>
                  Hide all: <input type=checkbox on:change={doHideAll}>
                </div>
                <Table>
                  <tr>
                    <td>Name</td>
                    <td>Type</td>
                    <td>Summary</td>
                    <td>Sample</td>
                    <td>Format</td>
                    <!-- <td>Key</td> -->
                    <td>Hide</td>
                  </tr>
                {#each data.instances[0].columns as column}
                  <tr>
                    {#if column.expr}
                    <td><a href="javascript:void 0" on:click={()=>{editName=column.name;addColOpen=true;}}>{column.name}</a></td>
                    {:else}
                    <td>{column.name}</td>
                    {/if}
                    <td>{column.type}</td>
                    <td>{column.text || column.expr}</td>
                    <td>{column.sample}</td>
                    <td><input type=text value="{column.format || ""}"></td>
                    <!-- <td><input type=checkbox checked={column.iskey || false}></td> -->
                    <td><input type=checkbox bind:checked={column.hide} ></td>
                  </tr>
                {/each}
                </Table>  
        
                <Button on:click={()=>{addColOpen=true}} class='btn-sm'>Add column</Button>
              </Card>
            {/if}
          </div>
        </div>
      {/if}  <!-- colToggleOpen -->

      {#if !addToggleOpen } 
      <a href="javascript:void(0)" on:click={()=>{addToggleOpen=!addToggleOpen}}>Add new data version</a>
      {/if}
      <Collapse isOpen={addToggleOpen}>
      <Card body>
        <!-- <Row> -->
          <!-- <Col> -->
            Add new data version:
          <!-- </Col> -->
        <!-- </Row> -->
        <InputGroup>
          <InputGroupAddon addonType="prepend">
            <InputGroupText class='inputPrefix'>Version key</InputGroupText>
          </InputGroupAddon>
          <Input bind:value={newInstanceKey}  />
        </InputGroup>
  
        
      <div>
        {#each sources as source, i}
          <div class="form-check-inline">
            <label class="form-check-label" >
              <input class="form-check-input" 
                    type="radio" 
                    name="dsRadio_{source.name}" 
                    value="{source.value}" 
                    checked={i==0} 
                    bind:group={dsType} 
                    disabled={source.readonly } />
              {source.label}
            </label>
          </div>
        {/each}  
      </div>
      {#if dsType == "text" }
      <div>
        <textarea name="text{name}" class="form-control {name}">{data}</textarea>
      </div>
      {/if}
      {#if dsType == "file" }
        <DataSetFileUpload bind:data done={uploaded} cancel={()=>{addToggleOpen=false}} />
      {/if}
      {#if dsType == "sheet" }
        <DataSetGoogleSheet bind:data />
      {/if}
      {#if dsType == "saved" }
        <ol>
          <li><input type=radio id={name}_saved_0 name={name}_saved><label for={name}_saved_0 >[SQL] Outstanding invoices</label></li>
          <li><input type=radio id={name}_saved_1 name={name}_saved><label for={name}_saved_1 >[SQL] Outstanding deliveries</label></li>
          <li><input type=radio id={name}_saved_2 name={name}_saved><label for={name}_saved_2 >[SQL] Current inventory</label></li>
          <li><input type=radio id={name}_saved_3 name={name}_saved><label for={name}_saved_3 >[SQL] Unmatch expenses</label></li>
        </ol>
      {/if}
      </Card>
      </Collapse>
    </Card>

  </div>
  </td>
  <td>
    <a href="javascript:void(0)" on:click={()=>{minimal=true}}>Close</a>
  </td>
</tr>

{/if}

{#if addColOpen}
  <DataSetAddCol bind:addColOpen={addColOpen} bind:data={data} editName={editName} done={()=>editName=""} />
{/if}
